var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LelyTable',{staticClass:"phone-log-table",attrs:{"compact":"","columns":_vm.columns,"items":_vm.phoneLog}})}
var staticRenderFns = []

export { render, staticRenderFns }